import React, { useCallback } from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { useHistory, useLocation } from 'react-router-dom';
import { menuItems } from './menuItems';

type IProps = {
  closeMenu?: () => void;
};

const LeftMenu: React.FC<IProps> = props => {
  const { pathname } = useLocation();
  const history = useHistory();

  const handleClick = useCallback(
    path => {
      history.push(path);
      if (props.closeMenu) {
        props.closeMenu();
      }
    },
    [history, props],
  );

  return (
    <div>
      <List>
        {menuItems.map(({ path, icon: Icon, title }) => {
          return (
            <List component="div" disablePadding key={path}>
              <ListItem
                button
                selected={pathname === path}
                onClick={() => handleClick(path)}
              >
                <ListItemIcon>
                  <Icon color="primary" />
                </ListItemIcon>
                <ListItemText primary={title} />
              </ListItem>
            </List>
          );
        })}
      </List>
    </div>
  );
};

export { LeftMenu };
